import {
  makeStyles,
  Grid,
  styled,
  withStyles,
  Tooltip,
} from '@material-ui/core';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '640px',
  margin: '0 auto',
  padding: '24px 16px 40px',
});

export const Section = styled('div')({
  width: '100%',
  background: '#2C325C',
  borderRadius: '12px',
  padding: '24px',
  marginBottom: '16px',
});

export const SectionTitle = styled('div')({
  fontSize: '15px',
  fontWeight: 700,
  color: '#ffffffcc',
  marginBottom: '20px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
});

export const BoxInputs = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
});

export const useStyles = makeStyles({
  logOut: {
    color: '#ffffff88',
    fontSize: '13px',
    textTransform: 'none',
    '&:hover': {
      color: '#FF6347',
      background: 'transparent',
    },
  },
  passwordInputs: {
    marginBottom: '12px',
  },
  formControl: {
    width: '100%',
  },
});

export const ExitTooltip = withStyles({
  tooltip: {
    fontSize: '11px',
  },
})(Tooltip);
